// Shared search highlight helpers, matching DataItemsTab behavior
// - Escapes regex input
// - Escapes HTML when no search term
// - When highlighting, injects <mark class="search-highlight"> around matches

export const escapeRegex = string => {
  return String(string || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

export const escapeHtml = text => {
  const div = document.createElement('div');
  div.textContent = text == null ? '' : String(text);
  return div.innerHTML;
};

export const highlightText = (text, searchQuery, className = 'search-highlight') => {
  const content = text == null ? '' : String(text);
  const query = searchQuery == null ? '' : String(searchQuery);
  if (!query.trim()) {
    return escapeHtml(content);
  }
  const regex = new RegExp(`(${escapeRegex(query.trim())})`, 'gi');
  return content.replace(regex, `<mark class="${className}">$1</mark>`);
};
